import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h5>{`Track 3: Product & Software design`}</h5>
    <p>{`"Production code, the place we embed our product's value in."`}</p>
    <ul>
      <li parentName="ul">{`Why do our codes go against our products? Where are user stories in our source code...?`}</li>
      <li parentName="ul">{`New user requirements arrive! Wait, what? Our codes cannot accommodate the new features?`}</li>
      <li parentName="ul">{`MUST need an effective way to model user requirements, so our code can grow as our product grows in order to receive faster feedback from our market.`}</li>
      <li parentName="ul">{`MUST NOT compromise the value of your product! Many mature methodologies like DDD and agile development have come out for years to solve problems about both product design and software architecture. It's time to make a difference!`}</li>
      <li parentName="ul">{`Including:`}<ol parentName="li">
          <li parentName="ol">{`Product's requirement refinement.`}</li>
          <li parentName="ol">{`Product's value stream and design.`}</li>
          <li parentName="ol">{`Product codes modularization using DDD tactics`}</li>
        </ol></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      